import type { Component } from 'vue'
import { defineAsyncComponent } from 'vue'

/**
 * Registry mapping MCP tool names to visualization components.
 *
 * To add a new visualization type:
 * 1. Create a Vue component with props: { toolInput, toolResult }
 * 2. Add it here with the matching MCP tool name
 * 3. Register the corresponding MCP tool on the server
 */
const VISUALIZATION_COMPONENTS: Record<string, Component> = {
  render_chart: defineAsyncComponent(() => import('./AiChartResult.vue')),
  render_marker_map: defineAsyncComponent(() => import('./AiMapResult.vue')),
  render_heatmap: defineAsyncComponent(() => import('./AiMapResult.vue')),
  render_choropleth: defineAsyncComponent(() => import('./AiMapResult.vue')),
  render_los_map: defineAsyncComponent(() => import('./AiMapResult.vue')),
  render_turning_movement: defineAsyncComponent(() => import('./AiTurningMovementResult.vue')),
  render_traffic_heatmap_animated: defineAsyncComponent(
    () => import('./AiAnimatedHeatmapResult.vue'),
  ),
}

export function getVisualizationComponent(toolName?: string): Component | null {
  if (!toolName) return null
  return VISUALIZATION_COMPONENTS[toolName] ?? null
}

export function isVisualizationTool(toolName?: string): boolean {
  return !!toolName && toolName in VISUALIZATION_COMPONENTS
}
